class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    /* 2026-09-18 (P2-15): Frueher registrierte renderContents() bei JEDEM
       Rendern einen neuen Overlay-Listener, ohne den alten zu entfernen -
       close.bind(this) erzeugt jedes Mal eine neue Funktion, die sich nicht
       deduplizieren laesst. Nach n Add-to-Carts lief close() n+1 mal pro
       Klick. Ein einziger, stabiler Handler loest das. */
    this.boundClose = this.close.bind(this);
    this.bindOverlay();

    this.setHeaderCartIconAccessibility();
  }

  /* Genau einen Overlay-Listener garantieren - auch nachdem der Drawer-
     Inhalt neu gerendert wurde. */
  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay) return;
    overlay.removeEventListener('click', this.boundClose);
    overlay.addEventListener('click', this.boundClose);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    /* 2026-09-18 (P0-2): Signal fuer fremde Overlays, die sonst ueber dem
       geoeffneten Warenkorb landen. Beobachtet: Das Klaviyo-Popup
       ("25 % auf Ihre erste Bestellung") legte sich direkt nach dem
       Add-to-Cart ueber den Drawer und verdeckte "Zur Kasse" - also genau
       im Moment der hoechsten Kaufabsicht. Unterdrueckt in
       snippets/biberna-cro-fixes.liquid. Gleiches Muster wie
       'bib-atc-sichtbar' in sections/sticky-add-to-cart.liquid. */
    document.documentElement.classList.add('bib-cart-offen');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('bib-cart-offen');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.bindOverlay();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  /* 2026-10-11 (P1-5): Nur .bib-drawer-swap tauschen, nicht .drawer__inner.
     So bleiben .cart__ctas und damit die Wallet-iFrames stehen (vorher
     388 ms Neuaufbau pro Mengenaenderung = mobiler INP).

     Dawns updateQuantity() ruft diese Methode ZWEIMAL: einmal fuer die
     Section-Liste der Anfrage, einmal beim Rendern - und zwischen beiden
     setzt es cart-drawer.is-empty. Deshalb kann hier zur Renderzeit
     entschieden werden: Leerer Warenkorb (oder Wrapper fehlt, z. B. in
     einem aelteren Markup) -> kompletter Tausch wie bisher, weil der
     Leerzustand ausserhalb des Wrappers liegt. */
  getSectionsToRender() {
    const drawer = document.querySelector('cart-drawer');
    const komplett =
      !drawer || drawer.classList.contains('is-empty') || !drawer.querySelector('.bib-drawer-swap');
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: komplett ? '.drawer__inner' : '.bib-drawer-swap',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
